export const getAllActivityRefs = (state) => {
  return state.activities.allRefs;
};
